import { BaseModel } from "../base.model";

export class UserPermission extends BaseModel {
  id: number;
  name: string;
  description: string;
}
